import {ROUTES} from '../../../config'

export const getInitialProps = async ({routeInfo, context: {i18n, domain}}) => {
  const {
    location: {
      pathname: path,
      query: {year: yearParam}
    },
    params: {
      make: makeUrlParam,
      model: modelUrlParam,
      bodyType: bodyTypeUrlParam,
      doors: doorsUrlParam,
      version: versionUrlParam,
      versionId
    }
  } = routeInfo
  const {culture} = i18n

  const serverErrors = []

  const initialTechnicalDetailsInfoFactory = async () => {
    const getVersionInfo = async () => {
      try {
        return await domain.get('get_version_info_vehicles_use_case').execute({
          make: makeUrlParam,
          model: modelUrlParam,
          bodyType: bodyTypeUrlParam,
          doors: doorsUrlParam,
          version: versionUrlParam,
          versionId,
          path,
          year: yearParam
        })
      } catch (error) {
        serverErrors.push(error)
      }
    }

    const initialpageInfoResponse = await getVersionInfo()

    const pageInfoResponse = initialpageInfoResponse?.versionInfo

    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

    const [[seoDataError, seoDataResponse], tagclouds, [, breadcrumbs]] = await Promise.all([
      domain.get('get_seo_data_use_case').execute({
        culture,
        pageName,
        params: {
          make: makeUrlParam,
          model: modelUrlParam,
          bodyType: bodyTypeUrlParam, // TODO: check how to get bodyTypeIds MTR-56077
          doors: doorsUrlParam,
          version: versionUrlParam,
          versionId,
          fuelType: pageInfoResponse?.specifications.fuelType,
          initDate: pageInfoResponse?.initMarketedDate,
          year: pageInfoResponse?.year
        }
      }),
      domain.get('get_tagcloud_seo_use_case').execute({
        pageName,
        makeId: pageInfoResponse?.makeId,
        modelId: pageInfoResponse?.modelId
      }),
      domain.get('get_breadcrumbs_breadcrumb_use_case').execute({
        pageName,
        params: {
          section: makeUrlParam,
          model: modelUrlParam,
          version: pageInfoResponse?.specifications.version
        }
      })
    ])

    const seoData = seoDataResponse || {}

    const {
      TECHNICAL_DETAILS: {BODY_TYPE}
    } = ROUTES

    const urlToRedirect = `${BODY_TYPE.replace(':make', makeUrlParam)
      .replace(':model', modelUrlParam)
      .replace(':bodyType', bodyTypeUrlParam)
      .replace(':doors', doorsUrlParam)}/`

    const hasCriticalServerErrors = Boolean(serverErrors.length)

    return {
      ...(hasCriticalServerErrors && {__HTTP__: {redirectTo: urlToRedirect}}),
      bodyType: bodyTypeUrlParam,
      breadcrumbs,
      doors: doorsUrlParam,
      helmet: seoData.head,
      make: makeUrlParam,
      makeName: pageInfoResponse?.make,
      makeUrlParam,
      model: modelUrlParam,
      modelName: pageInfoResponse?.model,
      modelUrlParam,
      version: versionUrlParam,
      versionId,
      pageErrors: {
        seoDataError
      },
      pageName,
      tagclouds,
      year: pageInfoResponse?.year,
      ...(pageInfoResponse && {pageInfoResponse}),
      ...(Boolean(serverErrors.length) && {serverErrors})
    }
  }

  const initialTechnicalDetailsInfo = await initialTechnicalDetailsInfoFactory()

  return initialTechnicalDetailsInfo
}
